// takes product data and determines if compatible products should be hidden
const handleHideShowCompatibleProducts = ({ Series, SelectedSku }) => {
  if (Series) {
    // case series
    if (null === SelectedSku) {
      const seriesHasCompatible = Series.HasCompatibleProducts;
      const anySkusCompatible = Series.AnySkuHaveCompatibleProducts;
      showhideCompatibleProducts(seriesHasCompatible || anySkusCompatible);
    }
    // case sku
    else {
      showhideCompatibleProducts(
        SelectedSku?.HasCompatibleProducts || Series?.HasCompatibleProducts
      );
    }
  } else {
    showCompatibleProducts();
  }
};

// for events that handle the coveo compatible products section
const fireProductEvent = (eventName, productData) => {
  setTimeout(function() {
    const event = new CustomEvent(eventName, { detail: productData });
    document.dispatchEvent(event);
  }, 0);
};

const addToLocalStorage = (eventname, productData) => {
  setTimeout(function() {
    localStorage.setItem("productData", JSON.stringify(productData));
    localStorage.setItem("eventFired", JSON.stringify(eventname));
  }, 0);
};

const fireProductLoadedEvent = productData => {
  // if(productData.SelectedSku){
  //   fireProductEvent("triggerCoveoQuery", productData);
  // }
  //fireProductEvent("ProductLoaded", productData);
  addToLocalStorage("ProductLoaded", productData);
  fireProductEvent("afterProductLoaded", null);
};

const isRedirectFromLogin = document.referrer.includes("my_account");
let isFirstLoadFromRedirect = true;

const fireProductUpdatedEvent = productData => {
  //need to fire this event if accordion is already open
  fireProductEvent("triggerCoveoQuery", productData);

  const edgeCaseFirstLoadFromRedirectPageForEnhancedProduct =
    isFirstLoadFromRedirect && isRedirectFromLogin;

  var eventTobeFiredFromLocalStorage = JSON.parse(
    localStorage.getItem("eventFired")
  );

  if (
    eventTobeFiredFromLocalStorage ||
    edgeCaseFirstLoadFromRedirectPageForEnhancedProduct
  ) {
    addToLocalStorage(eventTobeFiredFromLocalStorage, productData);
    // ensures the edge case condition only happens once
    isFirstLoadFromRedirect = false;
  } else {
    addToLocalStorage("ProductUpdated", productData);
  }
};

const fireProductClearAllEvent = productData => {
  //need to fire this event if accordion is already open
  fireProductEvent("triggerClearAllCoveoQuery", productData);
};

// hides the whole compatible products section if backend logic determines there are no
const showhideCompatibleProducts = visible => {
  const container = document.getElementById("pdp-coveo-compatability-products");
  if (!container) return;

  const drawer = document.querySelector(
    ".pdp-coveo-compatability-products-drawer"
  );
  const searchInterface = document.querySelector(
    ".pdp-coveo-compatability-products-drawer .CoveoSearchInterface"
  );
  const productsPanel = searchInterface ? searchInterface.parentElement : null;
  const helperMsg = document.getElementById("compatibleProdInfoMsg");

  container.classList.remove("hidden");
  if (drawer) drawer.classList.remove("hidden");

  if (productsPanel) {
    productsPanel.style.display = visible ? "block" : "none";
  }

  if (helperMsg) {
    if (visible) {
      helperMsg.classList.add("hidden");
    } else {
      helperMsg.classList.remove("hidden");
    }
  }
};

const showCompatibleProducts = () => {
  showhideCompatibleProducts(true);
};

const hideCompatibleProducts = () => {
  showhideCompatibleProducts(false);
};

export default {
  handleHideShowCompatibleProducts,
  fireProductLoadedEvent,
  fireProductUpdatedEvent,
  showCompatibleProducts,
  hideCompatibleProducts,
  fireProductClearAllEvent
};
